<template lang="pug">
    #companion-guide-main
      BLoading(v-if="dailyStrategyLoading" :active="dailyStrategyLoading" :is-full-page="true")
      .companion-daily-strategy-card(v-else)
        .companion-daily-strategy-content-wrapper
          .companion-daily-strategy-content
            .companion-action-menu
              CompanionActionsMenu(:backButton="goBack")
            .show-daily-strategy-details
              .green-card(:style="{ backgroundColor: backgroundColor }")
                .cover-art
                  img(:src="strategyHeroImage")
              .daily-strategy-details-card
                .daily-strategy-topic-title {{ dailyStrategyData.TopicTitle }}
                .daily-strategy-number-title {{ dailyStrategyData.Title }}
                .chapters-info-title
                  WtSvgIcon( icon="icon_time" width="16px", height="16px" ).mt-1
                  span {{ dailyStrategyData.Duration }}
                .daily-strategy-part-summary(v-html="dailyStrategyData.Text")
        .companion-related-guides
          .is-flex.is-flex-direction-column
              .column.is-12.custom-padding(v-if="havingRelatedGuides")
                  .category-title Related guides
                  .guide-card-container
                      CompanionGuideCard.guide-card(
                        v-for="(guide, index) in RelatedGuides"
                        :key="index" :partNumber="guide.Number"
                        :previewImage="guide.PreviewImage"
                        :id="guide.GuidePartId"
                        :duration="guide.Duration"
                        :partTitle="guide.GuidePartTitle"
                        :partId="guide.GuidePartId"
                        :redirectTo="`/plan/guide/${guide.GuidePartId}`" )
        .companion-related-topic
          .is-flex.is-flex-direction-column
            .column.is-12.p-0(v-if="havingRelatedTopics")
              .category-title Related topics
              .topic-card-container
                  CompanionTopicCard.topic-card(
                    v-for="(topic, index) in RelatedTopics"
                    :key="index"
                    :previewImage="topic.PreviewImage"
                    :id="topic.Id"
                    :partTitle="topic.Title"
                    :numberOfGuides="topic.NumberOfGuides"
                    :redirectTo="`/plan/topic/${topic.Id}`")
    </template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import CompanionTopicCard from "@@/Companion/CompanionTopicCard";
import CompanionGuideCard from "@@/Companion/CompanionGuideCard";
import CompanionRightArrowCard from "@@/Companion/CompanionRightArrowCard";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "CompanionGuideDetail",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon,
    CompanionActionsMenu,
    CompanionTopicCard,
    CompanionGuideCard,
    CompanionRightArrowCard
  },
  mixins: [analyticsTrackingMixin],
  data() {
    return {
      dailyStrategyLoading: false,
      dailyStrategyData: {},
      backgroundColor: "#ffffff",
      strategyHeroImage: "",
      havingRelatedGuides: false,
      havingRelatedTopics: false,
      havingStrategiesForChange: true,
      RelatedGuides: [],
      RelatedTopics: []
    };
  },

  computed: {
    ...mapGetters("companion", ["getStrategyById"])
  },

  async mounted() {
    this.$watch(
      "$route.params.strategyId",
      async () => {
        try {
          this.trackFeatureView("learn", "learn_strategy");
          this.dailyStrategyLoading = true;
          const strategyId = this.$route.params.strategyId;
          let strategyObject = this.getStrategyById(strategyId);

          if (Object.keys(strategyObject).length === 0) {
            strategyObject = await this.fetchStrategy({
              strategyId: strategyId
            });
          }

          this.dailyStrategyData = strategyObject.data;
          this.strategyHeroImage = strategyObject.data.HeroImage;
          this.backgroundColor = "#" + strategyObject.data.BackgroundColor;
          this.RelatedGuides = strategyObject.data.RelatedGuides;
          this.RelatedTopics = strategyObject.data.Relatedtopics;
          this.havingRelatedGuides = this.RelatedGuides.length > 0;
          this.havingRelatedTopics = this.RelatedTopics.length > 0;

          this.dailyStrategyLoading = false;
        } catch (e) {
          this.dailyStrategyLoading = false;
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: e.message
          });
        }
      },
      { immediate: true }
    );
  },

  methods: {
    ...mapActions("companion", ["fetchStrategy"]),
    ...mapActions(["snackBar"]),

    goBack() {
      window.history.back();
    }
  }
};
</script>

<style scoped>
#companion-guide-main .companion-daily-strategy-card {
  width: 70%;
  margin: auto;

  .companion-daily-strategy-content-wrapper {
    background-color: white;
    border: 1px solid #d9dbe0;
    border-radius: 12px 12px 0px 0px;
    padding: 24px 24px 24px 24px;
    gap: 16px;
    left: 0;

    .companion-daily-strategy-content {
      .companion-action-menu {
        padding-bottom: 20px;
      }

      .show-daily-strategy-details {
        .green-card {
          max-height: 220px;
          border-radius: 16px;
          .cover-art {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cover-art img {
            max-height: 220px;
            padding: 20px;
          }
        }

        .daily-strategy-details-card {
          padding: 28px 16px 0px 0px;

          .daily-strategy-topic-title {
            color: #5a5c60;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.25px;
          }

          .daily-strategy-number-title {
            color: #1b1d20;
            font-size: 24px;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 0.18px;
            padding-top: 9px;
          }

          .chapters-info-title {
            display: flex;
            gap: 4px;
            align-items: center;

            color: #5a5c60;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            padding: 9px 0px 9px 0px;
          }

          .daily-strategy-part-summary {
            padding: 24px 0px 0px 0px;
            .avenir-medium {
              color: #1b1d20;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: 0.25px;
              padding-bottom: 8px;
            }

            p {
              color: #5a5c60;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: 0.25px;
              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }

  .companion-related-guides {
    padding: 32px 24px 0px 24px;
    background-color: #fbfbfb;
    margin: auto;

    .custom-padding {
      padding: 0px !important;

      .category-title {
        font-family: Manrope;
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.15px;
        color: #1b1d20;
        margin-bottom: 16px !important;
      }
      .guide-card-container {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;
        gap: 10px !important;

        .guide-card {
          margin: 0rem !important;
        }
      }
      .guide-card-container::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .companion-guide-chapters-wrapper {
    margin: auto;
    background: #fbfbfb;

    .guide-chapters {
      padding: 0px 24px;

      .chapters-title {
        color: #1b1d20;
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.15px;
        padding-bottom: 6px;
      }

      .chapters-list {
        .right-arrow-card {
          padding-top: 10px;
        }
      }
    }
  }

  .companion-related-topic {
    padding: 28px 24px 32px 24px;
    background-color: #fbfbfb;
    margin: auto;
    border-radius: 0px 0px 16px 16px;

    .category-title {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.15px;
      color: #1b1d20;
      margin-bottom: 16px !important;
    }
    .topic-card-container {
      display: flex;
      scrollbar-width: none;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
      gap: 8px !important;

      .topic-card {
        margin: 0rem !important;
        max-width: 35%;
      }
    }
    .topic-card-container::-webkit-scrollbar {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .companion-daily-strategy-card {
    min-width: 100%;
  }
}

@media (max-width: 480px) {
  .companion-daily-strategy-card {
    .companion-guide-chapters-wrapper {
      .chapters-title {
        padding-bottom: 10px;
      }
      .guide-chapters {
        padding: 0px;
        .chapters-list {
          .right-arrow-card {
            padding-top: 8px;
          }
        }
      }
    }

    .companion-guide-content-wrapper {
      width: 100%;
      padding: 20px 20px 20px 20px;
      .companion-guide-content {
        .show-guide-details {
          .guide-details-card {
            padding: 28px 1px 0px 1px;

            .guide-part-summary {
              .avenir-medium,
              p {
                padding-right: 40px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
